<template>
    <div :class="$style.my_games_block">
        <template v-if="isMounted">
            <Games
                v-if="games.length"
                :games="games"
                :gameLinkTarget="props.gameLinkTarget"
            />
            <EmptyBlock
                v-else
                :currentCountry="currentCountry"
            />
        </template>
    </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed, onMounted, ref } from 'vue'

import { useDetectShowEvent } from '@/composables/use-detect-show-interface-event'
import EmptyBlock from '@/pages/Homepage/components/MyGamesBlock/EmptyBlock.vue'
import Games from '@/pages/Homepage/components/MyGamesBlock/Games.vue'
import { useAppStore } from '@/store/app-store'
import { useMyGamesStore } from '@/store/my-games/my-games-store'
import type { LinkTarget } from '@/types'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

const props = defineProps<{
    gameLinkTarget: LinkTarget | undefined
}>()

const isMounted = useIsMounted()
const detectShowEvent = useDetectShowEvent()

const myGamesStore = useMyGamesStore()
const appStore = useAppStore()
const { myUnzippedGames } = storeToRefs(myGamesStore)

const games = computed(() => myUnzippedGames.value.slice(0, 8))
const currentCountry = ref('')

onMounted(() => {
    currentCountry.value = appStore.countryCode || ''
    detectShowEvent.trigger({
        id: 'my-games',
        interface_target: games.value.length ? 'my-games' : 'empty-my-games',
    })
})
</script>
<style module>
.my_games_block {
    height: 56px;
    margin-left: calc(var(--global-wide-scroller-padding-left) * -1);
}
</style>
